import { render, staticRenderFns } from "./HomeIdea.vue?vue&type=template&id=4c5ee6ff&scoped=true&"
import script from "./HomeIdea.vue?vue&type=script&lang=js&"
export * from "./HomeIdea.vue?vue&type=script&lang=js&"
import style0 from "./HomeIdea.vue?vue&type=style&index=0&id=4c5ee6ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ee6ff",
  null
  
)

export default component.exports